<template>
  <div id="contenedor-contrato-agregar-inventario">
    <v-form
      v-model="formularioValido"
      ref="formAgregarContratoInventario">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo inventario
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <template v-if="mixGetContratoInsumos.length < 1 && !$apollo.loading">
          <v-card flat>
            <v-card-text>
              <v-row justify="center" align="center">
                <v-alert class="mt-4" type="info">
                  El contrato no tiene insumos asignados.
                </v-alert>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <v-card-text
        v-else>
          <custom-date-picker
              cols="12"
              md="6"
              v-model="inventario.fecha"
              label="Fecha"
              :rules="[mixReglas.requerido]">
            </custom-date-picker>
          <!-- listado de insumos -->
          <v-list
            subheader
            dense>
            <template
              v-for="agrupador in listadoDeInsumosConAgrupador">
              <template>
                <v-subheader
                  :key="agrupador.agrupador">
                  {{ agrupador.agrupador }}
                </v-subheader>
                <v-divider
                  :key="`divider-${agrupador.agrupador}`">
                </v-divider>
                <template
                  v-for="insumo in agrupador.insumos">
                  <template>
                    <v-list-item
                      :key="insumo.id">
                      <v-list-item-title>
                        {{ insumo.insumo.descripcion }}
                      </v-list-item-title>
                      <v-list-item-action
                        style="width: 200px;">
                        <v-row
                          dense
                          align="center"
                          justify="space-around">
                          <v-col
                            cols="auto">
                            <v-btn
                              icon
                              @click="reducirInsumo(insumo)">
                              <v-icon>
                                mdi-minus
                              </v-icon>
                            </v-btn>
                          </v-col>
                          <v-col
                            cols="auto">
                            <v-chip
                              color="info"
                              class="text-subtitle-1">
                              {{ insumo.nuevaCantidad }}
                            </v-chip>
                          </v-col>
                          <v-col
                            cols="auto">
                            <v-btn
                              icon
                              @click="aumentarInsumo(insumo)">
                              <v-icon>
                                mdi-plus
                              </v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </template>
              </template>
            </template>
          </v-list>
        </v-card-text>
        <v-card-actions
          v-if="mostrarAcciones">
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            v-if="!mixGetContratoInsumos.length < 1"
            @click="mixAgregarContratoInventario"
            :disabled="!formularioValido || enviandoFormulario || inventario.insumos.length < 1"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixContratoInventarios from './mixContratoInventarios';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoAgregarInventario',
  mixins: [mixContratoInventarios],
  props: {
    idContrato: {
      type: String,
      requided: true,
    },
    mostrarAcciones: {
      type: Boolean,
      requided: false,
      default: true,
    },
  },
  components: {
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      listadoInsumos: [],
      insumos: [],
      inventario: {
        idContrato: this.idContrato,
        fecha: '',
        insumos: [],
      },
    };
  },
  methods: {
    aumentarInsumo(insumo) {
      const nuevoInsumo = insumo;
      nuevoInsumo.nuevaCantidad += 1;
    },
    reducirInsumo(insumo) {
      const nuevoInsumo = insumo;
      if (nuevoInsumo.nuevaCantidad <= 0) return;
      nuevoInsumo.nuevaCantidad -= 1;
    },
    limpiarFormulario() {
      this.$refs.formAgregarContratoInventario.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    listadoDeInsumosConAgrupador() {
      return [
        {
          agrupador: 'Personal',
          insumos: this.listadoInsumos
            .filter(({ insumo }) => insumo.tipo === 1)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
        {
          agrupador: 'Maquinaria',
          insumos: this.listadoInsumos
            .filter(({ insumo }) => insumo.tipo === 2)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
        {
          agrupador: 'Equipo',
          insumos: this.listadoInsumos
            .filter(({ insumo }) => insumo.tipo === 3)
            .sort((a, b) => a.insumo.orden - b.insumo.orden),
        },
      ];
    },
  },
  watch: {
    listadoInsumos: {
      handler(listado) {
        const listadoInsumosReportados = listado
          .filter(({ nuevaCantidad }) => nuevaCantidad > 0);

        this.inventario.insumos = listadoInsumosReportados
          .map(({ idInsumo, nuevaCantidad }) => ({
            idInsumo,
            cantidad: nuevaCantidad,
          }));
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">

</style>
